import { Button, Chip, CircularProgress, Divider, IconButton, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { Link, Navigate, useParams } from "react-router-dom";
import api, { useUpdateSurveyMutation } from "./surveysApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { Field, FieldArray, Form, Formik } from "formik";
import Frame from "@/components/Frame";
import { Add, Delete, DeleteOutline } from "@mui/icons-material";
import { EmptyState } from "@/components";
import { Trash, Trash2 } from "lucide-react";
import ROUTES from "@/constants/routes";

const EMPTY_QUESTION = {
    title: '',
}

const EMPTY_OPTION = {
    title: '',
}

const SurveyEditPage = () => {
    const { organizationId, surveyId } = useParams<{ organizationId: string; surveyId: string }>();
    const survey = api.endpoints.fetchSurvey.useQueryState({
        organizationId: organizationId || skipToken,
        surveyId: surveyId || skipToken,
    });
    const test = api.endpoints.fetchSurvey.useQuery({
        organizationId: organizationId || skipToken,
        surveyId: surveyId || skipToken,
    });
    const [updateSurvey, surveyMutation] = useUpdateSurveyMutation();

    if (!survey.data) {
        // query();
    }

    return (
        <Stack spacing={2}>
            {survey.isLoading ? (
                <Stack flex={1} alignItems="center" py={5}>
                    <CircularProgress/>
                </Stack>
            ) : !survey.data ? (
                'No encontrado'
                // <Navigate to="/not-found" replace={true} />
            ) : (
                
                <Formik
                    initialValues={{
                        ...survey.data
                    }}
                    onSubmit={(values) => {
                        if (!organizationId || !surveyId) return;

                        updateSurvey({
                            organizationId,
                            surveyId,
                            payload: values 
                        })
                    }}
                >
                    {({ values, setFieldValue, handleSubmit }) => {
                        return (
                            <Stack spacing={2}>
                                <Form>
                                    <FieldArray name="questions">
                                        {({ push, replace, remove }) => (
                                            <Stack spacing={2}>
                                                <TextField
                                                    label="Título"
                                                    value={values.title}
                                                    onChange={(e) => setFieldValue('title', e.target.value)}
                                                />
                                                    <Stack spacing={2}>
                                                    <Typography variant="h3">Preguntas</Typography>

                                                    {values?.questions?.length ? (
                                                        <Stack spacing={2}>
                                                            {values.questions.map((question, questionIndex) => (
                                                                // <Frame key={question.id}>
                                                                    <Stack spacing={2}  key={question.id}>
                                                                        <Divider>
                                                                            <Chip
                                                                                color="primary"
                                                                                label={`Pregunta ${questionIndex + 1}`}
                                                                                onDelete={() => remove(questionIndex)}
                                                                                sx={{ paddingX: 1 }}
                                                                            />
                                                                        </Divider>
                                                                        <Field
                                                                            fullWidth
                                                                            label="Título"
                                                                            name={`questions.${questionIndex}.title`}
                                                                            as={TextField}
                                                                            size="small"
                                                                        />
                                                                        <Frame>
                                                                            <Stack spacing={2}>
                                                                                <Typography variant="h5">Opciones:</Typography>
                                                                                
                                                                                    {question?.options?.length ? (
                                                                                        <Stack spacing={2}>
                                                                                            {(question?.options ?? []).map((option, optionIndex) => (
                                                                                                <Stack direction="row" spacing={2} key={`option-${optionIndex}`}>
                                                                                                    <Field
                                                                                                        fullWidth
                                                                                                        label={`Opción ${optionIndex + 1}`}
                                                                                                        name={`questions.${questionIndex}.options.${optionIndex}.title`}
                                                                                                        as={TextField}
                                                                                                        size="small"
                                                                                                    />
                                                                                                    <Tooltip arrow placement="top" title={`Eliminar opción ${optionIndex + 1}`}>
                                                                                                        <IconButton onClick={() => {
                                                                                                            const question = {...values.questions[questionIndex]};
                                                                                                            const options = question.options.filter((_, index) => index !== optionIndex);
                                                                                                            replace(questionIndex, { ...question, options });
                                                                                                        }}>
                                                                                                            <Trash2 />
                                                                                                        </IconButton>
                                                                                                    </Tooltip>
                                                                                                </Stack>
                                                                                            ))}
                                                                                            <Stack alignItems="center">
                                                                                                <Button
                                                                                                    startIcon={<Add/>}
                                                                                                    variant="text"
                                                                                                    onClick={() => {
                                                                                                        const question = {...values.questions[questionIndex]};
                                                                                                        const options = question?.options ?? [];
                                                                                                        options.push(EMPTY_OPTION);
                                                                                                        replace(questionIndex, { ...question, options });
                                                                                                    }}
                                                                                                >Agregar Opción</Button>
                                                                                            </Stack>
                                                                                        </Stack>
                                                                                        
                                                                                    ) : (
                                                                                        <Stack p={3}>
                                                                                            <EmptyState
                                                                                                title="Sin Opciones"
                                                                                                action={{
                                                                                                    children: 'Agregar Opción',
                                                                                                    onClick: () => {
                                                                                                        const question = {...values.questions[questionIndex]};
                                                                                                        const options = question?.options ?? [];
                                                                                                        options.push(EMPTY_OPTION);
                                                                                                        replace(questionIndex, { ...question, options });
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        </Stack>
                                                                                    )}
                                                                                
                                                                            </Stack>
                                                                        </Frame>
                                                                    </Stack>
                                                                // </Frame>
                                                            ))}
                                                            <Stack alignItems="center">
                                                                <Button
                                                                    variant="text"
                                                                    startIcon={<Add/>}
                                                                    onClick={() => push(EMPTY_QUESTION)}
                                                                >Agregar Pregunta</Button>
                                                            </Stack>
                                                        </Stack>
                                                    ) : (
                                                        <Frame>
                                                            <Stack p={3}>
                                                                <EmptyState
                                                                    title="Sin Preguntas"
                                                                    action={{
                                                                        children: 'Agregar Pregunta',
                                                                        onClick: () => push(EMPTY_QUESTION)
                                                                    }}
                                                                />
                                                            </Stack>
                                                        </Frame>
                                                    )}
                                                </Stack>
                                            </Stack>
                                        )}
                                    </FieldArray>
                                </Form>
                                <Divider/>
                                <Stack justifyContent="flex-end" direction="row" spacing={2}>
                                    <Button
                                        size="large"
                                        variant="outlined"
                                        disabled={surveyMutation.isLoading}

                                        component={Link}
                                        to={ROUTES.organizations.surveys.details
                                            .replace(':organizationId', organizationId ?? '')
                                            .replace(':surveyId', surveyId ?? '')
                                        }
                                    >Cancelar</Button>
                                    <Button size="large" color="success" onClick={handleSubmit} disabled={surveyMutation.isLoading}>Guardar</Button>
                                </Stack>
                            </Stack>
                        )}}
                </Formik>
            )}
        </Stack>
    );
}

export default SurveyEditPage;
